import Vue from 'vue'

import rejectedTransformer from './../../transformers/sinister/rejectedQuotation'
import moment from 'moment'

function urlParamsTransformer(options) {
  const from = options.from ? moment(options.from).format('YYYY/MM/DD'): null
  const to = options.to ? moment(options.to).format('YYYY/MM/DD'): null
  const text = !!options.searchQuery ? options.searchQuery : undefined
  return {
    page: options.page,
    size: options.pageSize,
    page_size: options.pageSize,
    text,
    from,
    to,
  }
}
export default (opts) => {
  return Vue.$http.get(`/purchase/reject-quantification-report/`, { params: urlParamsTransformer(opts) })
    .then(response => {
      const paginationInfo = {...response.data, results: null}
      const data = response.data.results

      const quantificationList = rejectedTransformer.fetchCollection(data)

      return { quantificationList, paginationInfo } 
    })
}


// WEBPACK FOOTER //
// ./src/services/sinister/fetchRejectedQuantifications.js